import React, {FC, useMemo} from 'react';

import {ChannelModel} from '../../libs/shared/core/src/models/api/channelModel';
import {
  ConjunctionRenderer,
  ItemsFormatter,
  ItemsFormatterItem,
  NameDecorator,
  OthersTextDecorator,
} from './itemsFormatter';

/*
 * Props.
 */

interface ChannelsFormatterProps {
  /** The channels to render. */
  channels: ReadonlyArray<ChannelModel>;
  /** The maximum number of names to display. */
  limit?: number;
  /** Render channel name. */
  renderChannelName?: NameDecorator;
  /** Render "X others" text. */
  renderOthersText?: OthersTextDecorator;
}

/*
 * Constants.
 */

const channelsConjunctionRenderer: ConjunctionRenderer = (visibleNames, otherNames) => (
  <>
    {visibleNames}, {otherNames}
  </>
);

/*
 * Component.
 */

export const ChannelsFormatter: FC<ChannelsFormatterProps> = (props) => {
  const {channels, limit, renderChannelName, renderOthersText} = props;
  const items: ReadonlyArray<ItemsFormatterItem> = useMemo(
    () =>
      channels.map((channel) => ({
        id: channel.id,
        name: channel.displayName,
      })),
    [channels],
  );

  return (
    <ItemsFormatter
      items={items}
      limit={limit}
      renderName={renderChannelName}
      renderOthersText={renderOthersText}
      renderConjunction={channelsConjunctionRenderer}
    />
  );
};
